import styled from 'styled-components';

const ButtonBase = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  border-radius: ${props => {
    if (props.size === 'icon') return props.theme?.borderRadius?.['2xl'] || '1.25rem';
    return props.theme?.borderRadius?.['2xl'] || '1.25rem';
  }};
  font-size: 0.9375rem;
  font-weight: 500;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
  outline: none;
  
  @media (min-width: 1024px) {
    font-size: 1rem;
  }
  
  @media (min-width: 1440px) {
    font-size: 1.0625rem;
  }
  
  &:focus-visible {
    outline: 2px solid ${props => props.theme?.colors?.ring || '#3b82f6'};
    outline-offset: 2px;
  }
  
  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  
  svg {
    pointer-events: none;
    width: 1.25rem;
    height: 1.25rem;
    flex-shrink: 0;
    
    @media (min-width: 1024px) {
      width: 1.375rem;
      height: 1.375rem;
    }
    
    @media (min-width: 1440px) {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;

export const Button = styled(ButtonBase)`
  height: ${props => {
    if (props.size === 'sm') return '2.5rem';
    if (props.size === 'lg') return '3.25rem';
    if (props.size === 'icon') return '2.75rem';
    return '2.75rem';
  }};
  padding: ${props => {
    if (props.size === 'sm') return '0 1rem';
    if (props.size === 'lg') return '0 2.5rem';
    if (props.size === 'icon') return '0';
    return '0 1.25rem';
  }};
  
  @media (min-width: 1024px) {
    height: ${props => {
      if (props.size === 'sm') return '2.75rem';
      if (props.size === 'lg') return '3.5rem';
      if (props.size === 'icon') return '3rem';
      return '3rem';
    }};
    padding: ${props => {
      if (props.size === 'sm') return '0 1.25rem';
      if (props.size === 'lg') return '0 3rem';
      if (props.size === 'icon') return '0';
      return '0 1.5rem';
    }};
  }
  
  @media (min-width: 1440px) {
    height: ${props => {
      if (props.size === 'sm') return '3rem';
      if (props.size === 'lg') return '3.75rem';
      if (props.size === 'icon') return '3.25rem';
      return '3.25rem';
    }};
    padding: ${props => {
      if (props.size === 'sm') return '0 1.5rem';
      if (props.size === 'lg') return '0 3.5rem';
      if (props.size === 'icon') return '0';
      return '0 1.75rem';
    }};
  }
  
  ${props => {
    if (props.variant === 'default') {
      return `
        background-color: ${props.theme?.colors?.primary || '#3b82f6'};
        color: ${props.theme?.colors?.primaryForeground || '#ffffff'};
        &:hover {
          background-color: ${props.theme?.colors?.primary || '#3b82f6'}dd;
        }
      `;
    }
    if (props.variant === 'secondary') {
      return `
        background-color: ${props.theme?.colors?.secondary || '#f3f4f6'};
        color: ${props.theme?.colors?.secondaryForeground || '#111827'};
        &:hover {
          background-color: ${props.theme?.colors?.secondary || '#f3f4f6'}cc;
        }
      `;
    }
    if (props.variant === 'ghost') {
      return `
        background-color: transparent;
        color: ${props.theme?.colors?.foreground || '#111827'};
        &:hover {
          background-color: ${props.theme?.colors?.accent || '#f3f4f6'};
          color: ${props.theme?.colors?.accentForeground || '#111827'};
        }
      `;
    }
    if (props.variant === 'outline') {
      return `
        border: 1px solid ${props.theme?.colors?.input || '#d1d5db'};
        background-color: ${props.theme?.colors?.background || '#ffffff'};
        color: ${props.theme?.colors?.foreground || '#111827'};
        &:hover {
          background-color: ${props.theme?.colors?.accent || '#f3f4f6'};
          color: ${props.theme?.colors?.accentForeground || '#111827'};
        }
      `;
    }
    if (props.variant === 'destructive') {
      return `
        background-color: ${props.theme?.colors?.destructive || '#ef4444'};
        color: ${props.theme?.colors?.destructiveForeground || '#ffffff'};
        &:hover {
          background-color: ${props.theme?.colors?.destructive || '#ef4444'}dd;
        }
      `;
    }
    if (props.variant === 'link') {
      return `
        background-color: transparent;
        color: ${props.theme?.colors?.primary || '#3b82f6'};
        text-decoration: underline;
        text-underline-offset: 4px;
        padding: 0;
        height: auto;
        &:hover {
          text-decoration: underline;
        }
      `;
    }
    return '';
  }}
`;

Button.defaultProps = {
  variant: 'default',
  size: 'default',
};


